import React from "react";
import APEfficiencyImproved from "./APEfficiencyImproved";
import APFuelConsumption from "./APFuelConsumption";
import APCostSavings from "./APCostSavings";
import APEmissionCard from "./APEmissionCard";

const APCardsSection = ({ metaData, emissionData }) => {
 console.log("metaData in APCardsSection:", metaData);
  // Use the passed metaData or fallback to default data
  // const data = metaData ?? {
  //   before_additive_distance: 3017,
  //   before_additive_fuel: 700,
  //   before_efficiency: 72,
  //   after_additive_distance: 1250,
  //   after_additive_fuel: 625,
  //   after_efficiency: 84
  // };

  // Static data as per the client's comments >> temporary only
  const data = {
    before_additive_distance: 300,
    before_additive_fuel: 700,
    before_efficiency: 72,
    after_additive_distance: 258,
    after_additive_fuel: 625,
    after_efficiency: 84,
  };

  const metrics = [
    // {
    //   // title: "SFOC Improved",
    //   component: (
    //     <APEfficiencyImproved
    //       efficiencyData={{
    //         before: data.before_efficiency,
    //         after: data.after_efficiency,
    //       }}
    //     />
    //   ),
    // },
    {
      // title: "Fuel Consumption",
      component: (
        <APFuelConsumption
          fuelData={{
            before: metaData?.fuel_consumption?.before_additives?.total_fuel || 0,
            after: metaData?.fuel_consumption?.after_additives?.total_fuel || 0,
          }}
        />
      ),
    },
    // {
    //   // title: "Cost Savings",
    //   component: <APCostSavings />,
    // },
    {
      // title: "Emissions",
      component: (
        <APEmissionCard
          emissionData={emissionData}
        />
      ),
    },
  ];

  return (
    // <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
      {metrics.map((metric, index) => (
        <div key={index} className="space-y-3">
          {/* Card */}
          <div className="bg-white rounded-xl border border-gray-100 shadow-sm h-80 hover:shadow-md transition-shadow">
            {metric.component}
          </div>
          <div className="text-center">
            <h3 className="text-title font-semibold text-slate-700">
              {metric.title}
            </h3>
          </div>
        </div>
      ))}
    </div>
  );
};

export default APCardsSection;
